import PersonRegistrationService from '../services/person-registration-service';

export const personRegistration = {
  namespaced: true,
  state: {
    person: null,
  },
  actions: {
    initPersonRegistration({ commit }, person) {
      commit('setPersonRegistration', person);
    },
    create({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PersonRegistrationService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPersonRegistration', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setPersonRegistration', null);
      return PersonRegistrationService.get(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPersonRegistration', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    update({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PersonRegistrationService.update(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPersonRegistration', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setPersonRegistration(state, newState) {
      state.person = newState;
    },
  },
};
